'use client'

import React, { useState, useEffect, useRef } from "react"
import dayjs from "dayjs";
import { isCampaignActive } from "@/lib/campaignWindow";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useGlobalContext } from "../context/provider";
import Hashids from "hashids";
import CryptoJS from "crypto-js";
import { getLocalStorage, setLocalStorage } from "@/lib/localStorage";
import { imageLoader } from "@/lib/functionloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import FlashSaleSVG from "./FlashSaleSvg";
import { AxiosPostData } from '../context/axiosfunction'
import { useAddToCart } from "./AddCart";


const CardEbook = ({ Ebookdata, type }) => {
    const cardRef = useRef(null);
    const [width, setWidth] = useState(0);
    const router = useRouter()
    const { privateKey, refreshCart, DataShalve, setDataShalve, DataUser, API, headers, Token } = useGlobalContext()
    const { addToCart, contextHolder } = useAddToCart();
    const [timeLeft, setTimeLeft] = useState('')
    const [campaign, setCampaign] = useState(false)

    useEffect(() => {
        if (cardRef.current) {
            const card = cardRef.current.offsetWidth;
            setWidth(card);
        }
    }, []);

    // console.log(Ebookdata);


    const set_data = type === 'BookToSeries' ? {
        name: Ebookdata.name,
        check_new: dayjs().diff(dayjs(Ebookdata.createdAt), 'day') < 15,
        best_seller: Ebookdata.Ebdata[0]?.bestseller == '1',
        book_image: Ebookdata.Ebdata[0]?.book_image,
        series_number: Ebookdata.Ebdata[0]?.series_number,
        partner: Ebookdata.partner.name,
        author: Ebookdata.author.name,
        partner_id: Ebookdata.partner.id,
        coin_price: Number(Ebookdata.Ebdata[0]?.coin_price),
        review: Number(Ebookdata.Ebdata[0]?.score),
        book_series_id: Ebookdata.Ebdata[0]?.id,
        dis_per: Number(Ebookdata.Ebdata[0].dis_per),
        title: Ebookdata.Ebdata[0].title

    } : {
        name: Ebookdata['Edata.name'],
        check_new: dayjs().diff(dayjs(Ebookdata.createdAt), 'day') < 15,
        best_seller: Ebookdata.bestseller == '1',
        book_image: Ebookdata.book_image,
        series_number: Ebookdata.series_number,
        partner: Ebookdata['Edata.partner.name'],
        partner_id: Ebookdata['Edata.partner.id'],
        author: Ebookdata['Edata.author.name'],
        coin_price: Number(Ebookdata.coin_price),
        review: Number(Ebookdata.score),
        book_series_id: Ebookdata.id,
        dis_per: Number(Ebookdata.dis_per),
        normal_price: Number(Ebookdata.normal_price),
        campaign_type: Ebookdata['Bcam.campaign_type'] || Ebookdata?.Bcam?.campaign_type,
        campaign_id: Ebookdata['Bcam.campaign_id'] || Ebookdata?.Bcam?.campaign_id || Ebookdata?.campaign_id,
        campaign_discount: Number(Ebookdata['Bcam.campaign_discount'] || Ebookdata?.Bcam?.campaign_discount || 0),
        cam_start: Ebookdata.c_start || Ebookdata?.Bcam?.start_date || Ebookdata['Bcam.start_date'],
        cam_end: Ebookdata.c_end || Ebookdata?.Bcam?.end_date || Ebookdata['Bcam.end_date'],
        packbook: Ebookdata.packbook,
        title: Ebookdata.title
    }
    // console.log(set_data.campaign_id,set_data.cam_start,set_data.cam_end);/


    useEffect(() => {
        if (!set_data.campaign_id || !set_data.cam_start) {
            setCampaign(false);
            return;
        }

        const checkEvent = () => {
            const isEvent = isCampaignActive(set_data.cam_start, set_data.cam_end);
            setCampaign(isEvent);
        };

        checkEvent();

        if (set_data.campaign_type !== 'FlashSale') {
            return;
        }

        const interval = setInterval(checkEvent, 1000); // ตรวจสอบทุกวินาที

        return () => clearInterval(interval); // ล้าง interval ตอน unmount
    }, [set_data.campaign_id, set_data.campaign_type, set_data.cam_start, set_data.cam_end]);


    const OnDirectLink = (id) => {
        const hashids = new Hashids(privateKey, 6)
        const encodedID = hashids.encode(id)
        const targetUrl = set_data.packbook === 'yes'
            ? `/pack_set/${encodedID}`
            : `/ebook/${encodedID}`
        window.open(targetUrl, "_blank")
    }

    const OnDirectLinkPartner = (id) => {
        const hashids = new Hashids(privateKey, 6)
        const encodedID = hashids.encode(id)

        window.open(`/marketplace/${encodedID}_p`, "_blank")
    }



    return (
        <div className="text-left grid grid-cols-12 gap-6">
            {contextHolder}
            <div className=" group col-span-5 ">
                <button onClick={() => OnDirectLink(set_data.book_series_id)} ref={cardRef} className="relative w-full card-img-hold  aspect-[10/13]  rounded-[8px] cursor-pointer shadow-md overflow-hidden" >
                    <Image
                        src={set_data.book_image}
                        loader={imageLoader}
                        alt={set_data.name}
                        fill
                        className="object-cover"
                        sizes="(max-width: 640px) 45vw, (max-width: 960px) 30vw, 250px"
                        loading="lazy"
                        decoding="async"
                    />
                    {set_data.check_new && (
                        <div className="absolute top-0 right-[10px] w-[25px] md:w-[35px]">
                            <img
                                src="https://eve-image.eveebook.com/image.eveebook/web_image/tag/new.png"
                                alt="new_book"
                                loading="lazy"
                                decoding="async"
                                width={35}
                                height={35}
                            />
                        </div>
                    )}
                    {set_data.best_seller && (
                        <div className="absolute top-0 right-[10px] w-[25px] md:w-[35px]">
                            <img
                                src="https://eve-image.eveebook.com/image.eveebook/web_image/tag/bestseller.png"
                                alt="bestseller_book"
                                loading="lazy"
                                decoding="async"
                                width={35}
                                height={35}
                            />
                        </div>
                    )}
                    {campaign && set_data.cam_end && set_data.campaign_type === 'FlashSale' && (
                        <div className="absolute bottom-0 left-0 w-full z-10 text-[14px] md:text-[16px] font-bold pointer-events-none">
                            <FlashSaleSVG className="w-full h-auto" endtime={set_data.cam_end} />
                        </div>
                    )}
                </button>
            </div>

            <div className="col-span-7 flex flex-col justify-between">
                <div className="flex flex-col md:gap-3 ">
                    <button onClick={() => OnDirectLink(set_data.book_series_id)} className="text-left">
                        <div className={`text-primary text-[16px] xl:text-[22px] group-hover:text-[#EC008C] transition-colors duration-500 ease-in-out  w-full m-0 md:mt-2 overflow-hidden text-ellipsis whitespace-normal line-clamp-2 leading-snug h-[3.4rem]`}>
                            {set_data.name} {set_data.series_number > 0 ? 'เล่ม ' + set_data.series_number : ''}
                        </div>
                    </button>

                    <button className="text-left cursor-pointer" onClick={() => OnDirectLinkPartner(set_data.partner_id)}>
                        <div className="text-disable text-[12px] xl:text-[14px]">{set_data.partner}</div>
                    </button>
                    {/* <div className="">{set_data.title}</div> */}
                    {set_data.coin_price > 0 ?
                        set_data.dis_per ? (
                            <div className="text-[12px] xl:text-[14px] text-primary">
                                <div className="text-[12px] font-light xl:text-[14px] line-through decoration-2">{Math.floor(set_data.coin_price / ((100 - set_data.dis_per) / 100))}</div>
                                <span className="text-[16px] xl:text-[18px] text-danger"> {set_data.coin_price} บาท</span> <span></span>
                            </div>
                        ) : (campaign && set_data.campaign_id) ? (
                            <div className="text-[12px] xl:text-[14px] text-primary">
                                <div className="text-[12px] font-light xl:text-[14px] line-through decoration-2">{set_data.normal_price}</div>
                                {set_data.campaign_type === "Free" ? (
                                    <span className="text-[16px] xl:text-[18px] text-danger"> อ่านฟรี</span>
                                ) : (
                                    <span className="text-[16px] xl:text-[18px] text-danger">
                                        {Math.floor(set_data.coin_price * (100 - set_data.campaign_discount) / 100)} บาท
                                    </span>
                                )}
                            </div>
                        ) : (
                            <div className="text-[12px] xl:text-[14px] text-primary">
                                <span className="text-[16px] xl:text-[18px]"> {set_data.coin_price}</span> <span>บาท</span>
                            </div>
                        ) : (
                            <div>
                                <div className="text-[16px] xl:text-[18px] text-primary">อ่านฟรี</div>
                            </div>
                        )}

                    <div>
                        <div dangerouslySetInnerHTML={{ __html: set_data.title }} className="line-clamp-2 text-[12px] sm:text-[14px] md:text-[16px] md:line-clamp-5" />
                    </div>
                </div>

                <div className='grid grid-cols-2 gap-3 md:gap-5 items-center'>

                    {(!DataUser || !(Array.isArray(DataShalve) && DataShalve.some(item => Number(item) === Number(set_data.book_series_id)))) ?
                        <button onClick={() => addToCart(set_data)} className="text-[14px] xl:text-[18px] flex cursor-pointer flex-row items-center gap-3">
                            <img
                                className="h-[28px] mb-[5px]"
                                src="https://eve-image.eveebook.com/image.eveebook/mascot/basket1.png"
                                alt="add_basket"
                                loading="lazy"
                                decoding="async"
                                width={28}
                                height={28}
                            />
                            <span className="text-[#FF347F] hidden md:block">ใส่ตะกร้า</span>
                        </button>
                        :
                        <span className="text-success text-[14px] "><FontAwesomeIcon icon={faCircleCheck} /> มีแล้ว</span>
                    }

                    <button onClick={() => OnDirectLink(set_data.book_series_id)} className="hover:bg-[#ce326b] bg-[#FF347F] text-white p-2 md:px-5 rounded-[5px] text-[14px] md:text-[16px]">ดูรายละเอียด</button>
                </div>
            </div>

        </div>
    )
}

export default CardEbook 